export default __webpack_public_path__ + "static/media/ac_cfh.ee0786f6.bmp";